import React, { useState, useRef, useEffect } from 'react';
import styles from './3SCTerms&Conditions.module.css';

const TermsConsentModal = () => {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const scrollRef = useRef(null);

  // Check if user has scrolled to bottom
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10; // 10px tolerance
    setHasScrolledToBottom(isAtBottom);
  };

  // Reset state on component mount
  useEffect(() => {
    setHasScrolledToBottom(false);
    setIsChecked(false);
  }, []);

  const handleCancel = () => {
    window.location.href = '/';
  };


  const handleAccept = () => {
    if (hasScrolledToBottom && isChecked) {
      // Record timestamp for backend logging
      const timestamp = new Date().toISOString();
      console.log('Terms accepted at:', timestamp);
      // No API call needed here, just proceed to the next step
      window.location.href = '/sustainability/questionnaire';
    }
  };

  // Fix checkbox onChange handler
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const termsContent = `
1. Accuracy and Honesty

• All information provided in the audit form must be true, accurate, and complete to the best of your knowledge.
• Any intentional misrepresentation, omission, or falsification may result in disqualification from certification and potential removal from the 3SC platform.


2. Evidence Submission
• You agree to provide supporting documentation (“Proof Required”) for any claims made, upon request. This may include but is not limited to: certificates, invoices, product lists, packaging samples, HR records, policy documents, and supplier declarations.
• 3SC reserves the right to request additional proof or clarification for any response.

3. Confidentiality
• All information provided will be treated as confidential and used solely for the purposes of assessment, certification, and improvement recommendations.
• Only aggregate or anonymized data may be used for reporting or benchmarking purposes, unless explicit written consent is obtained for brand-specific disclosure.

4. Certification Validity and Use
• Achieving a 3SC badge or certification is valid for a period of 12 months from the date of issuance, unless otherwise stated.
• The 3SC badge or certificate may not be transferred, altered, or misrepresented. Any misuse may result in revocation of certification.
• You may display your achieved badge(s) and certification(s) as per the 3SC guidelines.

5. Continuous Improvement
• Your brand agrees to notify 3SC of any major changes in sourcing, manufacturing, labor practices, or other relevant sustainability aspects during the certification period.
• Reassessment may be required if significant changes occur.

6. Feedback and Dispute Resolution
• If you disagree with the assessment outcome, you may request a review, providing supplementary evidence if needed.
• 3SC will review disputes in good faith and provide a final decision.

7. Legal Compliance
• Participation in the 3SC audit does not exempt your brand from compliance with all applicable local, national, and international laws and regulations.

8. Intellectual Property
• The audit form, scoring system, and badge designs remain the intellectual property of Suspire India Ecosystems Pvt Ltd and may not be copied, distributed, or used for other purposes without written permission.

9. Right to Update Terms
• 3SC reserves the right to update these terms and conditions from time to time. Notice of any changes will be provided to participating brands.
`;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>3SC CERTIFICATE AUDIT FORM</h2>
          <h2 className={styles.title}>TERMS & CONDITIONS FOR BRANDS</h2>
          <p className={styles.subtitle}>
            By completing and submitting the 3SC Certificate Audit Form, your brand (“the Applicant”) agrees to the following terms and conditions:
          </p>
        </div>

        <div 
          ref={scrollRef}
          className={styles.scrollContainer}
          onScroll={handleScroll}
        >
          <div className={styles.termsContent}>
            {termsContent.split('\n').map((line, index) => {
              // if (line.trim() === '') return <br key={index} />;
              
              // if (line.startsWith('3SC CERTIFICATE') || line.startsWith('TERMS & CONDITIONS')) {
              //   return <h1 key={index} className={styles.mainHeading}>{line}</h1>;
              // }
              
              if (line.match(/^\d+\./)) {
                return <h3 key={index} className={styles.sectionHeading} style={{textTransform: 'uppercase'}}>{line}</h3>;
              }
              
              if (line.match(/^\d+\.\d+/)) {
                return <h4 key={index} className={styles.subHeading}>{line}</h4>;
              }
              
              return <p key={index} className={styles.paragraph}>{line}</p>;
            })}
          </div>
        </div>

        <div className={styles.checkboxSection}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              disabled={!hasScrolledToBottom}
              className={styles.checkbox}
            />
            <span className={`${styles.checkboxText} ${!hasScrolledToBottom ? styles.disabled : ''}`}>
              I have read and accept the Terms & Conditions of the 3SC process.
            </span>
          </label>
          
          {!hasScrolledToBottom && (
            <p className={styles.scrollHint}>
              Please scroll to the bottom to continue
            </p>
          )}
        </div>

        <div className={styles.buttonContainer}>
          <button 
            className={styles.cancelButton}
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button 
            className={`${styles.acceptButton} ${(!hasScrolledToBottom || !isChecked) ? styles.disabled : ''}`}
            onClick={handleAccept}
            disabled={!hasScrolledToBottom || !isChecked}
          >
            Accept & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsConsentModal;